import moment from "moment"
import React, { useState, createContext } from "react"

export const defaultReminderDateTimeFormat = "YYYY-MM-DD 23:59:00"
export const defaultReminderDateTime = moment(new Date()).format(defaultReminderDateTimeFormat)
export const defaultReminderPayload = {
    patientId: null,
    name: "",
    reminderTypeId: null,
    deadline: defaultReminderDateTime,
    time: moment(new Date()).format("HH:mm"),
    recurrence: {
        frequency: 1,
        frequencyUnit: "week",
        onlyRecurrenceDate: defaultReminderDateTime,
        recurrenceDays: []
    },
    timeBefore: 10,
    timeBeforeUnit: "minute"
}

export const ReminderContext = createContext({
    reminder: null,
    setReminder: () => {}
})

export const ReminderProvider = (props) => {
    const { children } = props
    const [reminder, setReminder] = useState(defaultReminderPayload)

    return (
        <ReminderContext.Provider
            value={{
                reminder,
                setReminder
            }}
        >
            {children}
        </ReminderContext.Provider>
    )
}
